import { render, staticRenderFns } from "./LuPriorityDialog.vue?vue&type=template&id=17e5843b"
import script from "./LuPriorityDialog.vue?vue&type=script&lang=js"
export * from "./LuPriorityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports